import devCustom from './components/devCustom.vue';
export default {
  components: {
    devCustom: devCustom
  },
  data: function data() {
    return {
      //渠道自定义
      formId: 138
    };
  },
  methods: {}
};